import { render, staticRenderFns } from "./ExamPC.vue?vue&type=template&id=4f4a6bba&scoped=true&"
import script from "./ExamPC.vue?vue&type=script&lang=js&"
export * from "./ExamPC.vue?vue&type=script&lang=js&"
import style0 from "./ExamPC.vue?vue&type=style&index=0&id=4f4a6bba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4a6bba",
  null
  
)

component.options.__file = "ExamPC.vue"
export default component.exports